import _slicedToArray from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { createEventSenderStats2NonAuth } from '@spotify-internal/event-definitions/es5/events/createEventSenderStats2NonAuth';
import Utilities from './utilities';

var StatsSender =
/*#__PURE__*/
function () {
  function StatsSender() {
    _classCallCheck(this, StatsSender);
  }

  _createClass(StatsSender, [{
    key: "_addEventsToEventSenderStatsData",

    /**
     * Collect data for EventSenderStats
        * @param essData - The input intermediary object for stats collection
     *
     * @param events - The input EventGroup to collect data from
     */
    value: function _addEventsToEventSenderStatsData(essData, events) {
      Object.keys(events).map(function (type) {
        for (var i = 0; i < events[type].length; i++) {
          var event = events[type][i];

          if (event.sequence_number < essData[event.sequence_id][event.event_name].sequence_number_min) {
            essData[event.sequence_id][event.event_name].sequence_number_min = event.sequence_number;
          }

          essData[event.sequence_id][event.event_name].storage_size++;
        }
      });
    }
    /**
     * Initialises the data for EventSenderStats
     *
     * @param essData - The input intermediary object for stats collection
     *
     * @param sequenceNumberCounters - Object containing counters for all
     * event_name-sequence_id pairs already entered into stats
     *
     * @param sequenceId - The current sequenceId
     */

  }, {
    key: "_initializeESSEventData",
    value: function _initializeESSEventData(essData, sequenceNumberCounters, sequenceId) {
      if (!Object.keys(essData).includes(sequenceId)) {
        essData[sequenceId] = {};
      }

      for (var _i = 0, _Object$entries = Object.entries(sequenceNumberCounters); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        essData[sequenceId][key] = {
          sequence_number_min: value + 1,
          sequence_number_next: value + 1,
          storage_size: 0
        };
      }
    }
    /**
     * Formats the collected data into EventSenderStats2UnauthEventData
        * @param essData - The input intermediary object for stats collection to be formatted
     *
     * @return EventSenderStats2NonAuthEventData - the final format of the statistics data for consumption in backend
     */

  }, {
    key: "_formatESS2UnauthEventData",
    value: function _formatESS2UnauthEventData(essData) {
      var formattedData = {
        sequence_ids: [],
        event_names: [],
        loss_stats_num_entries_per_sequence_id: [],
        loss_stats_event_name_index: [],
        loss_stats_storage_sizes: [],
        loss_stats_sequence_number_mins: [],
        loss_stats_sequence_number_nexts: []
      };
      Object.entries(essData).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            sequenceId = _ref2[0],
            eventBlock = _ref2[1];

        if (Utilities.isMissingFromArray(formattedData.sequence_ids, sequenceId)) {
          formattedData.sequence_ids.push(sequenceId);
          formattedData.loss_stats_num_entries_per_sequence_id.push(Object.keys(eventBlock).length);
        } else {
          var sequenceIdIndex = formattedData.sequence_ids.indexOf(sequenceId);
          formattedData.loss_stats_num_entries_per_sequence_id[sequenceIdIndex] += Object.keys(eventBlock).length;
        }

        Object.entries(eventBlock).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              eventName = _ref4[0],
              eventData = _ref4[1];

          Utilities.pushToArrIfMissing(formattedData.event_names, eventName);
          var eventNameIndex = formattedData.event_names.indexOf(eventName);
          formattedData.loss_stats_event_name_index.push(eventNameIndex);
          var eventDataKeys = Object.keys(eventData);

          for (var i = 0; i < eventDataKeys.length; i++) {
            var statsEntryKey = "loss_stats_".concat(eventDataKeys[i], "s");
            var statsEntry = formattedData[statsEntryKey];
            statsEntry.push(eventData[eventDataKeys[i]]);
          }
        });
      });
      return formattedData;
    }
    /**
     * Creates an ESS2NonAuth event from the unsent events in this._events.
        * @param events - The unsent events from persistance / memory storage
     *
     * @param sequenceNumberCounters - The sequence number counters from getAllSequenceNumberCounters() in sequenceIdGenerator
     *
     * @param sequenceId - The current sequenceId from the sequenceIdGenerator
     *
     * @return EventSenderStats2NonAuthEvent, the 'message' content, to be wrapped and batched
     */

  }, {
    key: "createESSEvent",
    value: function createESSEvent(events, sequenceNumberCounters, sequenceId) {
      var essData = {};

      this._initializeESSEventData(essData, sequenceNumberCounters, sequenceId);

      this._addEventsToEventSenderStatsData(essData, events);

      var essEvent = createEventSenderStats2NonAuth(this._formatESS2UnauthEventData(essData));
      return essEvent;
    }
  }]);

  return StatsSender;
}();

export { StatsSender as default };